import Button from "@/components/Button/index";
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import rem from "@/utils/rem";
import PropTypes from "prop-types";

const DisableEtrIssuance = ({ "data-testid": dataTestId = 'etr-issuance', visible, hide, handleSubmit, body }) => {
	return (
		<Modal visible={visible} close={hide}>
			<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>Disabling ETR Issuance</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div>
					{body ?? <div>
						<div className="etr-issuance-modal__content center">
							<p>
								Are you sure you want to disable ETR
								issuance?
							</p>
							<p>
								Disabling ETR Issuance will
								disable the ability to issue ETR.
							</p>
						</div>
					</div>}
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<div className="tnc-modal__confirmation_actions">
						<Button
							data-testid={`${dataTestId}-cancel`}
							ghost
							round
							noborder
							reject
							submit={() => hide()}
							text="Cancel"
						/>
						<Button
							data-testid={`${dataTestId}-confirm`}
							full
							round
							error
							submit={() => {
								handleSubmit()
								hide()
							}}
							text="Confirm"
						/>
					</div>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};

DisableEtrIssuance.propTypes = {
	"data-testid": PropTypes.string,
	visible: PropTypes.bool,
	hide: PropTypes.func,
	handleSubmit: PropTypes.func,
	body: PropTypes.node,
};

export default DisableEtrIssuance;
